"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openOnboarding = openOnboarding;
exports.closeOnboarding = closeOnboarding;
function openOnboarding(onboardingData) {
    window?.openOnboarding?.(onboardingData);
}
function closeOnboarding() {
    window?.closeOnboarding?.();
}
